import { useAtom } from 'jotai'
import { useCallback } from 'react'
import { userToRemoveAtom } from '../state/adminAtom'
import { useDeleteAdminUser } from '../hooks/useDeleteAdminUser'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material'
import { Button } from '@app/components/Atoms/Button'

export const DeleteUserConfirmModal = () => {
  const [userToRemove, setUserToRemove] = useAtom(userToRemoveAtom)
  const deleteUserMutation = useDeleteAdminUser()

  const handleDeleteUser = useCallback(async () => {
    if (!userToRemove) return
    deleteUserMutation.mutate(userToRemove.user_uuid, {
      onSuccess: () => {
        setUserToRemove(null)
      },
    })
  }, [userToRemove, deleteUserMutation, setUserToRemove])

  return (
    <Dialog
      open={!!userToRemove}
      onClose={() => setUserToRemove(null)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>Remove User?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: '8px' }}>
          Are you sure you want to delete <strong>{userToRemove?.email || 'this user'}</strong>?
        </DialogContentText>
        <DialogContentText>
          This will remove the user from the system and they will no longer be able to access the
          application.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setUserToRemove(null)}
          variant="outlined"
          disabled={deleteUserMutation.isPending}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDeleteUser}
          variant="contained"
          disabled={deleteUserMutation.isPending}
        >
          {deleteUserMutation.isPending ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
